// extracted by mini-css-extract-plugin
export var boldText = "_6a-4";
export var checkboxContainer = "_6a-6";
export var closeIcon = "_6a-i";
export var container = "_6a-0";
export var drawer = "_6a-8";
export var drawerContent = "_6a-9";
export var extraSmallText = "_6a-5";
export var fulfillmentGroupTable = "_6a-e";
export var largeText = "_6a-3";
export var loadingSpinnerContainer = "_6a-j";
export var mediumText = "_6a-2";
export var narrow = "_6a-f";
export var notificationLink = "_6a-l";
export var packageCheckIconContainer = "_6a-7";
export var slideoutHeaderActions = "_6a-g";
export var slideoutHeaderActionsShifted = "_6a-h";
export var slideoutHeaderContainer = "_6a-a";
export var slideoutModal = "_6a-c";
export var stickyHeaderWrapper = "_6a-b";
export var table = "_6a-k";
export var tableContainer = "_6a-d";
export var tertiaryText = "_6a-1";